import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class CertificationsIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.statusButtons = this.statusButtons.bind(this);
    this.activate = this.activate.bind(this);
    this.archive = this.archive.bind(this);
    this.loadData = this.loadData.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/fornecedores', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  ActionsButtons (cell, row) {
    var botao = '';
    var url = '/fornecedor/editar/' + cell;

    if (row.active == 1) {
      botao = (
        <div className="btn-group">
          <button className={'btn btn-danger btn-sm'} onClick={() => this.archive(row.id)}>
            <i className="fa fa-fw fa-power-off"></i>
          </button>
          <Link className={'btn btn-primary btn-sm'} to={url}>
            <i className="fa fa-fw fa-pencil"></i>
          </Link>

        </div>
      );
    } else {
      botao = (
        <div className="btn-group">
          <button className={'btn btn-success btn-sm'} onClick={() => this.activate(row.id)}>
            <i className="fa fa-fw fa-power-off"></i>
          </button>
          <Link className={'btn btn-primary btn-sm'} to={url}>
            <i className="fa fa-fw fa-pencil"></i>
          </Link>

        </div>
      );
    }

    return botao;
  }

  statusButtons (cell, row) {
    var label = '';
    if (row.active == 1) {
      label = (
        <span className="label label-success">{this.locale.Fornecedores.ListaDeFornecedores.ativo}</span>
      );
    } else {
      label = (
        <span className="label label-danger">{this.locale.Fornecedores.ListaDeFornecedores.arquivado}</span>
      );
    }

    return label;
  }


  // Fetch ativando um item
  activate(id) {
    var confirm = window.confirm(this.locale.Fornecedores.ListaDeFornecedores.ativar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/fornecedor/ativar/' + id, { method: 'PUT', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({data: responseJson.data});
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Fetch deletando um item
  archive(id) {
    var confirm = window.confirm(this.locale.Fornecedores.ListaDeFornecedores.arquivar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/fornecedor/desativar/' + id, { method: 'PUT', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({data: responseJson.data});
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }
  

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Fornecedores.ListaDeFornecedores.titulo}</h3>
      <Link to="/fornecedor/cadastrar" className="btn btn-primary pull-right"><i className="fa fa-plus"></i> {this.locale.Fornecedores.ListaDeFornecedores.botaoAdicionarFornecedor}</Link>
      <div className="clearfix"></div>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Fornecedores.ListaDeFornecedores.tabela.semFornecedores}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.Fornecedores.ListaDeFornecedores.tabela.ID}</TableHeaderColumn>
        <TableHeaderColumn dataField="name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Fornecedores.ListaDeFornecedores.tabela.Nome}</TableHeaderColumn>
        <TableHeaderColumn dataField="email" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Fornecedores.ListaDeFornecedores.tabela.Email}</TableHeaderColumn>
        <TableHeaderColumn dataField="phone" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Fornecedores.ListaDeFornecedores.tabela.Telefone}</TableHeaderColumn>
        <TableHeaderColumn dataField="country_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Fornecedores.ListaDeFornecedores.tabela.Pais}</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.statusButtons} width='100'>{this.locale.Fornecedores.ListaDeFornecedores.tabela.Status}</TableHeaderColumn>
        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>{this.locale.Fornecedores.ListaDeFornecedores.tabela.Acoes}</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default CertificationsIndex;



// WEBPACK FOOTER //
// ./src/Components/Suppliers/SuppliersIndex.js